'use client';

import clsx from 'clsx';

import styles from './Icons.module.css';
import { EditIconProps } from './types';
import config from 'config-base';

const EditIcon = ({ id, url, className }: EditIconProps) => {
  const handleEdit = () => {
    url && window.open(url, 'Data', 'height=720,width=1080');
  };

  return config.brandCode === '0' ? <span id={id} data-testid={`edit-btn-${id}`} onClick={handleEdit} className={clsx(styles.editIcon, className)}></span> : null;
};

export default EditIcon;
